import React from 'react';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { getAppStore } from '../../AppStore';
import { CreateProjectAction, CreateWorkbookAction } from '../Explorer/CreateContent/CreateContentActionsList';
import { CreateContentButtonLocations } from '../Explorer/CreateContent/CreateContentButton';

export function newWorkbookButton(): JSX.Element {
  const appState = getAppStore().getState();
  const createWorkbookAction = CreateWorkbookAction;
  if (createWorkbookAction.isVisible(appState, 'workbook', CreateContentButtonLocations.SiteSpace) && createWorkbookAction.isClickable(appState)) {
    const reduxAction = createWorkbookAction.createReduxAction();
    const handleClick = () => getAppStore().dispatch(reduxAction);
    return (
      <ButtonWidget
        children={Messages.newWorkbook()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        testId={'action-new-workbook'}/>
    );
  }
  return null;
}

export function newProjectButton(): JSX.Element {
  const appState = getAppStore().getState();
  const createProjectAction = CreateProjectAction;
  if (createProjectAction.isVisible(appState, 'project', CreateContentButtonLocations.SiteSpace) && createProjectAction.isClickable(appState)) {
    const reduxAction = createProjectAction.createReduxAction();
    const handleClick = () => getAppStore().dispatch(reduxAction);
    return (
      <ButtonWidget
        children={Messages.newProject()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        testId={'action-new-project'}/>
    );
  }
  return null;
}
